import React from 'react'
import MediaQuery, { useMediaQuery } from 'react-responsive'
import { BREAKPOINTS_IN_PX, Breakpoints } from 'styles/breakpoints'

interface BreakpointProps {
  on: Breakpoints
  children: React.ReactNode | ((matches: boolean) => React.ReactNode)
}

const Breakpoint: React.FC<BreakpointProps> = ({ children, on }) => (
  <MediaQuery query={`(min-width: ${BREAKPOINTS_IN_PX[on]}px)`}>
    {children}
  </MediaQuery>
)

// All breakpoints are using min-width, so every breakpoint includes bigger
// resolutions
export const useBreakpoint = (on: Breakpoints) =>
  useMediaQuery({ minWidth: BREAKPOINTS_IN_PX[on] })

/** Returns true for mobile and bigger screens in portrait mode (min-width: 325px) */
export const useForMobile = () => useBreakpoint('xxs')
/** Returns true for screens bigger than mobile in portrait mode (min-width: 512px) */
export const useForLargerThanMobile = () => useBreakpoint('xs')
/** Returns true for tablet and bigger screens in portrait mode (min-width: 768px) */
export const useForTablet = () => useBreakpoint('sm')
/** Returns true for screens bigger than 1200px in portrait mode */
export const useForBigScreen = () => useBreakpoint('lg')

export default Breakpoint
